module.exports = __webpack_public_path__ + "checkbox-sign-in-widget.7846b2f8c6d0a7ca69fdd3d3c294e92d.png";